import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaUserShield, FaLayerGroup, FaBookOpen, FaTasks,
  FaTags, FaSitemap, FaProjectDiagram, FaBoxes, FaBuilding, FaGlobeAsia, FaMapMarkedAlt, FaCity, FaCoins,FaUsers,FaChartLine,FaUsersCog,FaFolderOpen,FaWallet 
} from 'react-icons/fa';

const settingSections = [
  {
    title: 'Other Settings',
    items: [
      { title: 'Country', icon: <FaGlobeAsia />, path: '/dashboard/country' },
      { title: 'State', icon: <FaMapMarkedAlt />, path: '/dashboard/state' },
      { title: 'City', icon: <FaCity />, path: '/dashboard/city' },
      { title: 'Currancy', icon: <FaCoins />, path: '/dashboard/currancy' }, 
    ],
  }, 
];

const Setting = () => {   
  return (
    <div className="container">
      <h3 className="mb-2 mt-4">Master</h3>

      {settingSections.map((section, idx) => (
        <div key={idx} className="mb-4">
          <h5 className="mb-3 text-center">{section.title}</h5>
          <div className="row">
            {section.items.map((item,index) => (
              <div key={index} className="col-sm-2 mb-2">
                <NavLink to={item.path} className="text-decoration-none">
                  <div className="card text-center p-3 border h-100" style={{ borderRadius: '12px' }}>
                    <div className="text-primary-custom fs-4 mb-2">{item.icon}
                    <h6 className="mb-0 text-dark">{item.title}</h6>
                    </div>
                    
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Setting;
